import React, { Component } from "react";
import "./ProfileSidebar.scss";
import * as auth from "imports/auth";
import { NavLink } from "react-router-dom";

export default class ProfileSidebar extends Component {
    render() {
        let changePhone = phone => phone.substr(1) + phone.substr(0, 1);
        const { programTitle } = this.props;
        const user = auth.getUser();
        return (
            <aside id="profile-sidebar">
                <ul className="profile-sidebar__menu">
                    <li className="profile__info">
                        <img
                            src={
                                user.image
                                    ? user.image
                                    : "/images/img-avatar.svg"
                            }
                            alt="img-avatar"
                            className="avatar"
                        />
                        <span>
                            <label>
                                {user.firstName + " " + user.lastName}
                            </label>
                            <span>{changePhone(user.phoneNumber)}</span>
                        </span>
                    </li>
                    <li>
                        <NavLink activeClassName="current" to="/my-programs">
                            <i className="icon icon-dr-laptop"></i>
                            <span>دوره‌های من</span>
                        </NavLink>
                    </li>
                    <li
                        className="profile-sidebar__submenu"
                        style={
                            programTitle
                                ? { display: "block" }
                                : { display: "none" }
                        }
                    >
                        <ul>
                            <li>
                                <i className="icon icon-dr-certificate"></i>
                                <span>{programTitle}</span>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <NavLink activeClassName="current" to="/profile">
                            {/* <img src="/images/user-info.svg" alt="img-icon" className="icon" /> */}
                            <i className="icon icon-dr-certificate"></i>
                            <span>اطلاعات کاربری</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="invoice-nav" activeClassName="current" to="/invoices">
                            <img className="icon invoice-icon" src="/images/invoice-black.svg" alt="img-icon" />
                            {/* <i className="icon icon-dr-certificate"></i> */}
                            <span>صورت حساب</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            activeClassName="current"
                            to="/chat-list"
                            className="logout"
                        >
                            <img
                                className="chat-box-icon"
                                src="/images/nav-chat-icon.svg"
                            />
                            <span>صندوق پیام</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            className="notif-link"
                            activeClassName="current"
                            to="/notifications"
                        >
                            <img
                                className="notif-icon"
                                src="/images/nav-notif-icon.svg"
                            />
                            <span>اعلانات</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            activeClassName="current"
                            to="/logout"
                            className="logout"
                        >
                            <i className="icon icon-dr-exit"></i>
                            <span>خروج از حساب</span>
                        </NavLink>
                    </li>
                </ul>
            </aside>
        );
    }
}
